export default __webpack_public_path__ + "static/media/010_home.vp9.358f8e6a.webm";